export default __webpack_public_path__ + "static/media/bg-login.751223cf.png";